import parseNumber from 'ia-react-core/~/utils/format/#parseNumber';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import isObjectLike from 'lodash/isObjectLike';
import isNull from 'lodash/isNull';
import get from 'ia-react-core/~/utils/accessors/get';
import { Condition } from './Behavior';

export interface ClauseContext {
  originalInputs: string[];
}

export const truthy = () => (input: any) => Boolean(input);

export const falsy = () => (input: any) => !input;

export const empty = () => (input: any) => Boolean(input === '' || isUndefined(input) || isNull(input) || (isObjectLike(input) && isEmpty(input)));

export const filled = () => (input: any) => Boolean(input !== '' && !isUndefined(input) && !isNull(input) && !(isObjectLike(input) && isEmpty(input)));

export const is = (value: any) => (input: any) => value === input;

export const equals = (value: any) => (input: any) => isEqual(value, input);

export const greaterThan = (value: number) => (input: number | string) => parseNumber(input) > value;

export const greaterThanEqual = (value: number) => (input: number | string) => parseNumber(input) >= value;

export const lesserThan = (value: number) => (input: number | string) => parseNumber(input) < value;

export const lesserThanEqual = (value: number) => (input: number | string) => parseNumber(input) <= value;

export const longerThan = (length: number) => (input: any) => input.length > length;

export const longerThanEqual = (length: number) => (input: any) => input.length >= length;

export const shorterThan = (length: number) => (input: any) => input.length < length;

export const shorterThanEqual = (length: number) => (input: any) => input.length <= length;

export const typeOf = (type: string) => (input: any) => typeof input === type;

export const instanceOf = (Type: new(...args: any[]) => any) => (input: any) => input instanceof Type;

// Form clauses
export function touched(this: ClauseContext) {
  const [name] = this.originalInputs;
  const condition = new Condition({
    inputs: ['@form/touched'],
    clauses: [(touchedState) => get(touchedState, name)],
  });
  return condition;
}

export function untouched(this: ClauseContext) {
  const [name] = this.originalInputs;
  const condition = new Condition({
    inputs: ['@form/touched'],
    clauses: [(touchedState) => !get(touchedState, name)],
  });
  return condition;
}

export function dirty(this: ClauseContext) {
  const [name] = this.originalInputs;
  const condition = new Condition({
    inputs: ['@form/dirty'],
    clauses: [(dirtyState) => get(dirtyState, name)],
  });
  return condition;
}

export function pristine(this: ClauseContext) {
  const [name] = this.originalInputs;
  const condition = new Condition({
    inputs: ['@form/dirty'],
    clauses: [(dirtyState) => !get(dirtyState, name)],
  });
  return condition;
}

// Aliases
export const eq = equals;
export const gt = greaterThan;
export const gte = greaterThanEqual;
export const lt = lesserThan;
export const lte = lesserThanEqual;
